import { FunctionComponent } from "react";

interface Properties {
  values: (string | number)[];
}

export const UnorderedList: FunctionComponent<Properties> = ({ values }: Properties) => {
  return <ul>{
    values.map(value => <li key={ value }>{ value }</li>)
  }</ul>;
};